import { useState, useEffect } from 'react';
import { Storage } from '../constants/storage';
import { useSearchParams } from 'react-router-dom';
import { themes, defaultTheme } from '../config/themes';

export const useTheme = () => {
  const [searchParams] = useSearchParams();
  // Initialize from localStorage first, fallback to defaultTheme ('blue')
  const [currentTheme, setCurrentTheme] = useState(() => {
    const savedTheme = localStorage.getItem(Storage.app_theme);
    return (savedTheme && themes[savedTheme]) ? savedTheme : defaultTheme;
  });

  useEffect(() => {
    // Read theme from URL parameter
    const themeParam = searchParams.get('theme');

    // If URL has theme parameter, it overrides localStorage
    if (themeParam && themes[themeParam]) {
      setCurrentTheme(themeParam);
    }
  }, [searchParams]);

  useEffect(() => {
    // Apply theme to document root
    const theme = themes[currentTheme];
    if (theme) {
      // Apply CSS variables to :root
      const root = document.documentElement;
      Object.entries(theme.colors).forEach(([key, value]) => {
        root.style.setProperty(`--${key}`, value);
      });

      // Save to localStorage
      localStorage.setItem(Storage.app_theme, currentTheme);

      // Add data-theme attribute for CSS selectors
      root.setAttribute('data-theme', currentTheme);
    }
  }, [currentTheme]);

  return {
    theme: currentTheme,
    themeConfig: themes[currentTheme],
    setTheme: setCurrentTheme,
    availableThemes: Object.keys(themes),
  };
};
